export default "__VITE_PUBLIC_ASSET__7db6197c__"